/* eslint-disable */

declare interface Window {
  recruitee: any;
}

declare interface IFrameResizerFrame {
  iFrameResizer: {
    close: () => {};
  };
}

declare module 'kalendae/build/kalendae';
declare module 'iframe-resizer' {
  function iframeResizer(
    config: any,
    selectorOrFrame: string | HTMLIFrameElement,
  ): IFrameResizerFrame[];
}
